import { TorchmarkDataModel } from './models';
import {JanglService} from '../jangl/JanglService';

// common options
import * as  STATE_OPTIONS  from '../jangl/options/STATE_OPTIONS';


// vertical specific options
import { BEST_CALL_TIME_OPTIONS } from './options/BEST_CALL_TIME_OPTIONS';
import { LANGUAGE_OPTIONS } from "./options/LANGUAGE_OPTIONS";
import { HOW_DID_YOU_HEAR_OPTIONS } from "./options/HOW_DID_YOU_HEAR_OPTIONS";

export class TorchmarkFormDataService extends JanglService {

    constructor($http, $window) {
        super($http, $window);
        this.yearMin = 16;
        this.yearMax = 110;
    }

    capture(token, productType, data) {
        if (productType === 'life') {
            return this.captureLifeInsuranceLead(token, data);
        } else {
            return this.captureHealthInsuranceLead(token, data);
        }
    }

    newModel(defaults) {
        return new TorchmarkDataModel(defaults);
    }

    getStateOptions() { return STATE_OPTIONS; }
    getBestTimeToCallOptions() {return BEST_CALL_TIME_OPTIONS; }
    getLanguageOptions() {return LANGUAGE_OPTIONS; }
    getHowDidYouHearOptions() {return HOW_DID_YOU_HEAR_OPTIONS; }
    getAgeOptions() {
        let years = [];
        for(let i = 0; this.yearMin + i <= this.yearMax; i++) {
            let year = this.yearMin + i;
            years.push({ key: year, label: year });
        }
        return years;
    }

}

export default TorchmarkFormDataService;



// WEBPACK FOOTER //
// ./app/torchmark/service.js